import './BottomDrawer.scss'

import React from 'react'
import cx from 'classnames'
import { ANDROID, APPLE } from 'common/constants'
import { isHeaderHidden, deviceType, isDrawerTitleHidden } from 'common/util/features'

export const BottomDrawer = ({ title, isOpen, onClose, fullscreen, children, className }) => {
  const device = deviceType()
  const hideHeader = isHeaderHidden()
  const hideDrawerTitle = isDrawerTitleHidden()

  const clsName = cx('BottomDrawer', {
    'BottomDrawer__show': isOpen,
    'BottomDrawer__fullscreen': fullscreen,
    'BottomDrawer__fullscreen_apple': fullscreen && device === APPLE && !hideHeader,
    'BottomDrawer__fullscreen_android': fullscreen && device === ANDROID && !hideHeader,
    'BottomDrawer__fullscreen_no_header': fullscreen && hideHeader,
  })

  return (
    <div className={className}>
      {isOpen && <div className="BottomDrawer__backdrop" />}
      <div className={clsName}>
        {!hideDrawerTitle && (
          <div className="BottomDrawer__title">
            <span className="BottomDrawer__title-span">{title}</span>
            <button className="BottomDrawer__close-icon" onClick={onClose}>&times;</button>
          </div>
        )}
        <div className="BottomDrawer__body">
          {children}
        </div>
      </div>
    </div>
  )
}